import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ui-alert',
  templateUrl: './alert.component.html',
})
export class AlertComponent implements OnInit {
  @Input() type: 'success' | 'error' = 'success';
  @Input() classes: string;

  constructor() {}

  ngOnInit() {}
}
